import { Currency } from './currency';
import { Lang } from './lang';

export type MusicInfo = {
  id?: string | number;
  title: string;
  url: string;
  smart_url?: string;
};

export type ItemInfo = {
  code: string;
  title: string;
};

export type ArrangementInfo = ItemInfo & {
  instruments: string[];
  offer_id: number;
  price?: {
    BASE: PriceInfo;
    MIDI: PriceInfo;
    FINAL: PriceInfo;
  };
  url?: string;
};

export type PriceInfo = {
  PRINT_VALUE: string;
  VALUE: number;
  CURRENCY: Currency;
  STORE_ID?: string | null;
  offer_id?: number; // приходит в листе, не приходит в карточке
  variant?: string; // options: "BASE" maybe enum
};
export interface NotesCardQueryData {
  data: {
    article: string;
    id: number;
    note_id: string;
    title: string;
    h1: string;
    code: string;
    rating: string;
    rate?: string;
    tonality?: string;
    author_words?: string;
    author_music?: string;
    author?: string;
    licensed?: string;
    likes: number;
    views: number;
    vote_count: number;
    isempty: boolean;
    favorite: boolean;
    year: string;
    musicians?: MusicInfo[];
    pdfpages: number;
    img: {
      src: string;
      width: number;
      height: number;
    };
    mp3: string;
    genres: ItemInfo[];
    arrangement: {
      id: string;
      title: string;
    };
    instruments?: ItemInfo[];
    price: {
      BASE: PriceInfo;
      MIDI: PriceInfo;
      FINAL: PriceInfo;
    };
    text: string;
    arrangements?: ArrangementInfo[];
    isfree: boolean;
    complexity: {
      level: 10 | 20 | 30;
      title: string;
    } | null;
    collections?: {
      id: number;
      title: string;
      url: string;
    }[];
    signatureartist?: {
      title?: string;
      url?: string;
    };
    created: string;
    modified: string;
    CT_CPV_CATALOG_ANALOG_BACK: string;
    DOWNLOAD_PREVIEW_PDF_BACK: string;
    DOWNLOAD_PREVIEW_PDF_BANNER_BTN_BACK: string;
    DOWNLOAD_PREVIEW_PDF_BANNER_TITLE_BACK: string;
    NOTE_OTHER_ARRANGEMENT_BACK: string;
    NOTE_TAB_DSCR_TITLE_1_BACK: string;
  };
  lang: string;
  userID: string;
  filter: {
    ID: string;
    IBLOCK_ID: number;
  };
  meta: {
    meta_description: string;
    meta_keywords: string;
    meta_title: string;
    meta_h1: string;
  };
  breadcrumb: {
    title: string;
    url: string;
  }[];
}

export const NotesCardInitialDataRus = {
  data: {
    article: 'PSO000343',
    id: '17832',
    note_id: '17830',
    title: 'Пчеловод',
    code: 'rasa/pchelovod/piano-solo',
    rating: '4.09',
    likes: 17,
    views: 1020,
    vote_count: 7,
    isempty: false,
    year: '2019',
    musicians: [
      {
        id: '823',
        title: 'RASA',
      },
    ],
    img: {
      src: '/upload/resize_cache/iblock/206/768_1024_0/RASA_Pchelovod_Piano_Solo.jpg',
      width: 543,
      height: 768,
    },
    mp3: '/upload/note_files/736/RASA-_-Pchelovod-_-Piano-Solo.mp3',
    genres: [
      {
        code: 'pop',
        title: 'Поп',
      },
    ],
    arrangement: {
      code: 'piano-solo',
      title: 'Пианино.Соло',
    },
    instruments: [
      {
        code: 'piano',
        title: 'Пианино',
      },
      {
        code: 'guitar',
        title: 'Гитара',
      },
    ],
    price:
      {
        BASE: {
          PRINT_VALUE: '250 ₽',
          VALUE: 250,
          CURRENCY: Currency.RUB,
          STORE_ID: null,
        },
        MIDI: {
          PRINT_VALUE: '380 ₽',
          VALUE: 380,
          CURRENCY: Currency.RUB,
          STORE_ID: null,
        },
        FINAL: {
          PRINT_VALUE: '500 ₽',
          VALUE: 500,
          CURRENCY: Currency.RUB,
          STORE_ID: null,
        },
      },
    text: 'Ты пчела — я пчеловод.\nА мы любим мед.\nА мне повезет, с тобой мне повезет.\nТы пчела — я пчеловод.\nА мы любим мед.\nА мне повезет, с тобой мне повезет.\nТебя в танце унесет.\n\nНикто не узнает куда пропадали\nПчёлами летали до утра\nЖужжали жужжали мы над этажами\nМеня опьянила луна\n\n Бжж… Бжж… Бжж… Мы просто пчелы.\nБжж… Бжж… Бжж… Мы просто пчелы.\nБжж… Бжж… Бжж… На все готовы…\nБжж… Бжж… Бжж… На все готовы…\n\nТы пчела — я пчеловод.\nА мы любим мед.\nА мне повезет, с тобой мне повезет.\nТы пчела — я пчеловод.\nА мы любим мед.\nА мне повезет, с тобой мне повезет.\nТебя в танце унесет.\n\nТы пчела — я пчеловод.\nА мы любим мед.\nА мне повезет, с тобой мне повезет.\nТы пчела — я пчеловод.\nА мы любим мед.\nА мне повезет, с тобой мне повезет.\nТебя в танце унесет.\n\nГде бы не был с кем бы ты не был\nНебо поможет нам ярким светом\nВсе что захочешь тебе подарю\nМузыку света море волну\n\nДавай отложим с тобой дело\nМузыка двигает наше тело\nСердце пронзила пчела\nЯ полюбила тебя\n\n Бжж… Бжж… Бжж… Мы просто пчелы.\nБжж… Бжж… Бжж… Мы просто пчелы.\nБжж… Бжж… Бжж… На все готовы…\nБжж… Бжж… Бжж… На все готовы…\n\nТы пчела — я пчеловод.\nА мы любим мед.\nА мне повезет, с тобой мне повезет.\nТы пчела — я пчеловод.\nА мы любим мед.\nА мне повезет, с тобой мне повезет.\nТебя в танце унесет.\n\nТы пчела — я пчеловод.\nА мы любим мед.\nА мне повезет, с тобой мне повезет.\nТы пчела — я пчеловод.\nА мы любим мед.\nА мне повезет, с тобой мне повезет.\nТебя в танце унесет.',
    arrangements: [
      {
        code: 'piano-easy',
        title: 'Пианино.Easy',
        instruments: ['piano'],
        offer_id: 17831,
      },
      {
        code: 'piano-solo',
        title: 'Пианино.Соло',
        instruments: ['piano'],
        offer_id: 17832,
      },
      {
        code: 'piano-vocal',
        title: 'Пианино&Вокал',
        instruments: ['piano'],
        offer_id: 17833,
      },
      {
        code: 'guitar-tab',
        title: 'Гитара.Табы',
        instruments: ['guitar'],
        offer_id: 33429,
      },
    ],
    isfree: false,
  },
  lang: Lang.RU,
  userID: '2',
  filter: {
    ID: '17832',
    IBLOCK_ID: 5,
  },
};
